import * as React from "react";

const MenuInactive: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="currentColor"><g fill="none" fillRule="evenodd"><rect width="30" height="30" rx="2"/><rect width="20" height="2" x="5" y="7" fill="#464646" fillRule="nonzero" rx="1"/><rect width="20" height="2" x="5" y="14" fill="#464646" fillRule="nonzero" rx="1"/><rect width="20" height="2" x="5" y="21" fill="#464646" fillRule="nonzero" rx="1"/></g></svg>;
};

export default React.memo(MenuInactive);
